import styled from 'styled-components'
import { FiExternalLink, FiHelpCircle } from 'react-icons/fi'
import { Typography, P } from 'common/typography'
import { SecondaryButtonOutline as BtnOutline } from 'common/button'

const SecondaryButtonOutline = styled(BtnOutline)`
  svg {
    margin-right: 8px;
  }
`

function UpdateRepo({ repo }) {
  return (
    <SecondaryButtonOutline height="40" as="a" href={repo} target="_blank" rel="noopener noreferrer">
      <FiExternalLink size="20px" />
      Actualizar repositorio
    </SecondaryButtonOutline>
  )
}

const FieldTitleStyled = styled.div`
  margin: 16px 0 8px;
  display: flex;
  align-items: center;
  position: relative;
  h6 {
    flex-shrink: 0;
  }
  .field-tooltip {
    flex-shrink: 0;
    margin: 0 8px;
  }
  .tooltip {
    width: max-content;
    left: 0%;
    opacity: 0;
    visibility: hidden;
    max-width: calc(100vw - 112px);
    font-size: 12px;
    position: absolute;
    line-height: 20px;
    color: var(--white);
    background: var(--neutral90);
    border-radius: 4px;
    padding: 6px 8px;
    transition: 0.2s ease-in;
  }
  .field-tooltip {
    &:hover .tooltip {
      opacity: 1;
      visibility: visible;
    }
  }
  .tooltip-text {
    margin: 0;
  }
  @media(min-width: 768px) {
    position: static;
    margin: 24px 0 8px;
    .field-tooltip {
      position: relative;
    }
    .tooltip {
      max-width: 300px;
      /* left: 24px; */
      /* top: -120%; */
      z-index: 1;
      top: 120%;
      transform: translateX(-40%);
    }
  }
`

function FieldTitle({ title, children }) {
  return (
    <FieldTitleStyled>
      <Typography as="h6" className="field-tooltip-title">{title}</Typography>
      <div className="field-tooltip">
        <FiHelpCircle size="20px" />
        <div className="tooltip">
          {children}
        </div>
      </div>
    </FieldTitleStyled>
  )
}

function UpdateField({ description, repo }) {
  return (
    <>
      <P>{description}</P>
      <UpdateRepo repo={repo} />
    </>
  )
}

export { UpdateRepo, FieldTitle, UpdateField }
